import { useQuery, useManualQuery } from 'graphql-hooks';

export const MutationNoteOrder = `
  mutation UpdateOrderStatusNote($orderId: String!, $note: NoteStatus!){
  updateOrderStatusNote(orderId: $orderId, note: $note) {
    success
  }
}
`;

const useMutationNoteOrder = () => {
    const {
        loading,
        error,
        data: mutationNoteOrderResponse,
    } = useQuery(MutationNoteOrder);
    return { loading, error, mutationNoteOrderResponse };
};

const useMutationNoteOrderManual = () => {
    const [updateOrderStatusNote, { loading, error, data: mutationNoteOrderResponse }] =
        useManualQuery(MutationNoteOrder);
    return { updateOrderStatusNote, loading, error, mutationNoteOrderResponse };
};

export { useMutationNoteOrder, useMutationNoteOrderManual };